import React from "react";
import styles from "./style.module.css";
import { useRouter } from "next/router";
import {
  actions as urltrackActions,
  selectors as urltrackSelectors,
} from "../../../redux/slices/newLps/FillDarian";
import { useSelector } from "react-redux";
import useTranslation from "next-translate/useTranslation";

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const index = ({ slug }: { slug: string }) => {
  const { t, lang } = useTranslation("villesprovincescommunes");

  const urltrack = useSelector(urltrackSelectors.pageUrlsSelector);

  return (
    <div className={styles.urlTrack}>
      <div className={styles.urlTrackLink}>
        <a className={styles.link} href="/">
          <span>{t("Immobilier")}</span>
          <svg
            className={styles.arrowIcon2}
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 3.83332L10.6667 8.49999L6 13.1667"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      {urltrack?.length > 0
        ? urltrack.map((item, index) => (
            <>
              <span className={styles.urlTrackLink}>
                <a
                  href={item.path}
                  className={styles.link}
                  style={{
                    color: index == urltrack.length - 1 ? "black" : "#757e83",
                  }}
                >
                  <span>{t(capitalizeFirstLetter(item.name))}</span>
                  {index < urltrack.length - 1 ? (
                    <svg
                      className={styles.arrowIcon}
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 3.83332L10.6667 8.49999L6 13.1667"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : null}
                </a>
              </span>
            </>
          ))
        : null}
      {/* <div className={styles.urlTrackLink}>
        <div className={styles.link}>Location</div>
      </div>
      <svg
        className={styles.arrowIcon}
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 3.83332L10.6667 8.49999L6 13.1667"
          stroke="#BFC4C6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div className={styles.urlTrackLink}>
        <div className={styles.linkActive}>{slug}</div>
      </div> */}
    </div>
  );
};
export default index;
